export type Task1WsAuthPhase = "idle" | "auth_sent" | "invalid_auth_terminal";

export type InvalidAccessTokenResult = {
  shouldNotifyError: boolean;
  shouldClose: boolean;
};

const INVALID_AUTH_NOOP: InvalidAccessTokenResult = {
  shouldNotifyError: false,
  shouldClose: false,
};

/**
 * Task 1 websocket auth lifecycle (Fix B).
 *
 * A JWT rejected as "Invalid access token" must not be automatically resent
 * unchanged on that websocket session. Token selection (paid vs guest) is
 * owned by audioService onopen and is not part of this machine.
 */
export class Task1WsAuthPolicy {
  private phase: Task1WsAuthPhase = "idle";

  getPhase(): Task1WsAuthPhase {
    return this.phase;
  }

  canSendAuth(): boolean {
    return this.phase !== "invalid_auth_terminal";
  }

  isTerminal(): boolean {
    return this.phase === "invalid_auth_terminal";
  }

  onAuthSent(): void {
    if (this.phase === "invalid_auth_terminal") {
      return;
    }
    this.phase = "auth_sent";
  }

  onInvalidAccessToken(): InvalidAccessTokenResult {
    if (this.phase === "invalid_auth_terminal") {
      return INVALID_AUTH_NOOP;
    }
    this.phase = "invalid_auth_terminal";
    return { shouldNotifyError: true, shouldClose: true };
  }

  /** Cleanup / unmount: no further auth handshake on this instance. */
  markShutdown(): void {
    this.phase = "invalid_auth_terminal";
  }
}
